export default {
    name: 'Icon',
    props: {
        type: String
    }
}